import { render } from "./AssiignDialog.vue?vue&type=template&id=2010ef10"
import script from "./AssiignDialog.vue?vue&type=script&lang=js"
export * from "./AssiignDialog.vue?vue&type=script&lang=js"

import "./AssiignDialog.vue?vue&type=style&index=0&id=2010ef10&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__